import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppContent from "@/components/app_content/AppContent";
import AppHeader from "@/components/app_header/AppHeader";
import { LanguageProvider } from "@/components/LanguageProvider";
var MainPage = function () {
    return (_jsx(LanguageProvider, { children: _jsxs("div", { style: { width: '100%' }, children: [_jsx(AppHeader, {}), _jsx(AppContent, {})] }) }));
};
export default MainPage;
